<template>
  <div>
    <h4>Reminder</h4>
    <div v-for="(reminder,ind) in reminders">
      <div class="flex flex-col md:flex-row md:gap-4 w-full">
        <a-form-item label="Remind me" has-feedback>
          <a-select
            v-decorator="[`reminders[${ind}].option_date`,{ rules: [{ required: false }] }]"
            @change="(value) => handleChangeDate(value,ind)"
            style="width: 150px"
          >
            <a-select-option :value="1">1 days</a-select-option>
            <a-select-option :value="2">2 days</a-select-option>
            <a-select-option :value="3">3 days</a-select-option>
            <a-select-option :value="4">4 days</a-select-option>
            <a-select-option :value="7">1 weeks</a-select-option>
            <a-select-option :value="14">2 weeks</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Target date" has-feedback>
          <a-date-picker
            v-decorator="[`reminders[${ind}].target_date`,{rules: [{ required: false }] }]"
            :format="dateFormat"
            valueFormat="YYYY-MM-DD"
            placeholder="dd/mm/yyyy"
          />
        </a-form-item>
        <a-form-item class="w-full md:w-1/2" label="Notification type" has-feedback>
          <a-select
            v-decorator="[`reminders[${ind}].notification_type`,{ rules: [{ required: false}] }]"
            placeholder="Select Type Notification"
          >
            <a-select-option :value="1">
              Web and App
            </a-select-option>
            <a-select-option :value="2">
              Email
            </a-select-option>
            <a-select-option :value="3">
              Both
            </a-select-option>
          </a-select>
        </a-form-item>
        <feather-icon
          icon="MinusCircleIcon"
          @click="removeReminder(ind)"
          svg-classes="text-danger"
          class="self-end cursor-pointer mb-4"
        />
      </div>
    </div>
    <a-button type="primary" ghost shape="circle" icon="plus" class="plus-icon mt-5" @click="addReminder"/>
  </div>
</template>

<script>
import mixin from '@/views/mixin/mixin'

export default {
  name: "RemindersComponent" ,
  mixins:[mixin],
  props:{
    isReminderTask:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return{
      reminders: []
    }
  },
  methods: {
    addReminder(){
      this.$emit('addReminder')
    },
    handleChangeDate(value,ind) {
      this.$emit('changeOptionDate',value,ind)
    },
    removeReminder(i) {
      this.$emit('removeReminder',i)
    }
  },
  computed:{
    listName() {
      return this.isReminderTask ? 'reminders' : 'reminder'
    }
  }
}
</script>

<style scoped>

</style>
